import getStyle from './get-style';
export default function getHeight(el, defaultValue) {
    var width = getStyle(el, 'width', defaultValue);
    if (width === 'auto') {
        width = el.offsetWidth;
    }
    return parseFloat(width);
}
//# sourceMappingURL=get-width.js.map